import React, { FC } from 'react';

type Props = {
  props?: React.SVGProps<SVGSVGElement>;
  onClick?: () => void;
};

const IconEye: FC<Props> = ({ props, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 14"
      {...props}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        d="M12,16.1692023 C14.2781743,16.1692023 16.125,14.2959552 16.125,11.9851886 C16.125,9.67442197 14.2781743,7.80117487 12,7.80117487 C9.72182575,7.80117487 7.875,9.67442197 7.875,11.9851886 C7.875,14.2959552 9.72182575,16.1692023 12,16.1692023 Z M1,11.9851886 C1,11.9851886 5.12130675,5 12,5 C18.8786932,5 23,11.9851886 23,11.9851886 C23,11.9851886 18.8948055,19 12,19 C5.1051945,19 1,11.9851886 1,11.9851886 Z M10.625,11.9851886 C10.625,11.2095631 11.2406081,10.5905174 12,10.5905174 C12.7646856,10.5905174 13.375,11.2149326 13.375,11.9851886 C13.375,12.7608141 12.7593919,13.3798598 12,13.3798598 C11.2353144,13.3798598 10.625,12.7554446 10.625,11.9851886 Z"
        transform="translate(-1 -5)"
      />
    </svg>
  );
};

export default IconEye;
